// extracted by mini-css-extract-plugin
export default {"divSection":"Section_divSection__bqKfX","sectionTitle":"Section_sectionTitle__in2ym"};